<template>
  <div>
    <!-- 제목 -->
    <v-row class="title-wrap">
      <v-col cols="12" class="icon-title word-type pb-5"
        ><icon-celebration :width="24" :height="24" />{{
          $t('신규입사자')
        }}</v-col
      >
    </v-row>

    <!-- 신규입사자 리스트 -->
    <new-member-list></new-member-list>
  </div>
</template>

<script>
import IconCelebration from '@/assets/customIcon/IconCelebration.vue';
import NewMemberList from '@/components/member/NewMemberList.vue';

export default {
  data: () => ({}),
  components: {
    IconCelebration,
    NewMemberList,
  },
};
</script>

<style>
/* _list.scss 상세 */
</style>
